import React, { useMemo, ReactElement, FC } from 'react';
import { useCssHandles } from '../../utils/functions';

import IOMessage from './IOMessage';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Values = Record<string, any>;

interface Props {
	message: string;
	handleBase: string;
	markers: string[];
	values: Values;
	blockClass?: any;
}

const IOMessageWithMarkers: FC<Props> = ({ message, markers = [], blockClass, handleBase = '', values = {} }) => {
	const adjustedMarkers = markers ? markers : [];
	const CSS_HANDLES = useMemo(() => adjustedMarkers.map((marker) => `${handleBase}-${marker}`), [handleBase, markers]);

	const { handles }: any = useCssHandles('vtex-product-price-1-x', CSS_HANDLES, blockClass);

	const markerComponents = adjustedMarkers.reduce(
		(acc, marker) => {
			// for more information check https://github.com/formatjs/react-intl/blob/master/docs/Components.md#rich-text-formatting
			// eslint-disable-next-line react/display-name
			acc[marker] = (...chunks) => (
				<span key={marker} className={handles[`${handleBase}-${marker}`]}>
					{chunks}
				</span>
			);

			return acc;
		},
		{} as Record<string, (...chunks: string[]) => ReactElement>,
	);

	return (
		<IOMessage
			id={message}
			values={{
				...markerComponents,
				...values,
			}}
		/>
	);
};

export default React.memo(IOMessageWithMarkers);
